export enum RewriterFormatEnum {
  PlainText = 'plain-text',
  Markdown = 'markdown',
  AsIs = 'as-is',
}
